import type { CollisionInfo } from '@/types/api';
import { CollisionCard } from './CollisionCard';

interface CollisionWithFile {
  collision: CollisionInfo;
  fileName: string;
}

interface CollisionsListProps {
  collisions: CollisionWithFile[];
  onJumpToTime?: (seconds: number) => void;
  currentVideoTime?: number;
}

export const CollisionsList = ({
  collisions,
  onJumpToTime,
  currentVideoTime,
}: CollisionsListProps): React.ReactElement => {
  return (
    <>
      {collisions.map(({ collision, fileName }, index) => (
        <CollisionCard
          key={collision.id}
          collision={collision}
          fileName={fileName}
          sequentialNumber={index + 1}
          onJumpToTime={onJumpToTime}
          currentVideoTime={currentVideoTime}
        />
      ))}
    </>
  );
};
